function capitalizeWord(word) {
  return word.charAt(0).toLocaleUpperCase() + word.substring(1);
}

export default capitalizeWord;
